/* eslint-disable no-unused-vars */
import { Button, Heading, Input } from 'applaus-ui-kit'
import { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ReactSelect from 'react-select'
import { addPartnerInEvent } from '../../../../api/partner/addPartnerInEvent'
import {
  listPartners,
  ListPartnersResponse
} from '../../../../api/partner/listPartners'
import {
  clearModalAction,
  setAlertModalAction
} from '../../../../redux/AlertModal/actions'
import { ReduxState } from '../../../../redux/rootReducer'
import { history } from '../../../../routes/services/history'
import * as S from './AddPartner.styles'

type AddPartnerProps = {
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
  eventPartners: ListPartnersResponse[] | undefined
}

export const AddPartner = ({
  open,
  setOpen,
  eventPartners
}: AddPartnerProps) => {
  const dispatch = useDispatch()
  const [partners, setPartners] = useState<ListPartnersResponse[]>()
  const [optionsPartners, setOptionsPartners] =
    useState<{ label: string; value: string }[]>()
  const [selectedPartner, setSelectedPartner] = useState('')
  const [percentage, setPercentage] = useState('')
  const [submit, setSubmit] = useState(false)
  const { eventData } = useSelector(
    (state: ReduxState) => state.ManageEventReducer
  )

  useEffect(() => {
    if (eventPartners) {
      setPartners(eventPartners)
      setOptionsPartners(
        eventPartners.map((partner) => ({
          label: partner.name,
          value: partner.name
        }))
      )
    }
  }, [eventPartners])

  const addPartner = async () => {
    setSubmit(true)
    try {
      if (selectedPartner !== '' && percentage !== '') {
        setSubmit(false)
        const status = await addPartnerInEvent({
          email: partners!.filter(
            (partner) => partner.name === selectedPartner
          )[0].email,
          events: [
            {
              eventId: eventData!.id,
              revenuePercent: Number(percentage)
            }
          ]
        })

        if (status === 200) {
          dispatch(
            setAlertModalAction({
              buttonText: 'Ok',
              open: true,
              title: 'Parceiro adicionado com sucesso.',
              variant: 'success',
              click: () => {
                dispatch(clearModalAction())
                setOpen(false)
                setSelectedPartner('')
                setPercentage('')
              }
            })
          )
        }
      }
    } catch (e: any) {
      if (e.response.data.message === 'event not published') {
        dispatch(
          setAlertModalAction({
            buttonText: 'Ok',
            open: true,
            title: 'Você precisa publicar o evento para adicionar um parceiro.',
            description: 'Publique o evento.',
            variant: 'error'
          })
        )
      } else if (
        e.response.data.message === 'percentage for partners has been exhausted'
      ) {
        dispatch(
          setAlertModalAction({
            buttonText: 'Ok',
            open: true,
            title: 'Porcentagem do parceiro excede o limite.',
            description: 'Mude a porcetagem.',
            variant: 'error'
          })
        )
      } else {
        dispatch(
          setAlertModalAction({
            buttonText: 'Ok',
            open: true,
            title: 'Ocorreu um erro ao adicionar o parceiro.',
            description: 'Tente novamente.',
            variant: 'error'
          })
        )
      }
    }
  }

  return (
    <S.Container open={open}>
      <S.Form>
        <S.CloseIcon onClick={() => setOpen(false)} />
        <div className="title">
          <Heading variant="h5">Adicione o parceiro</Heading>
        </div>

        <div className="content">
          <label>Nome</label>
          <ReactSelect
            options={optionsPartners}
            value={optionsPartners?.filter(
              (partner) => partner.label === selectedPartner
            )}
            onChange={(e: any) => setSelectedPartner(e.value)}
            noOptionsMessage={() => 'Parceiro não encontrado'}
            placeholder="Escolha o parceiro"
            styles={S.customStyles}
          />
          <p className="error">
            {submit && selectedPartner === '' ? 'Selecione um parceiro' : ''}
          </p>
        </div>

        {selectedPartner ? (
          <div className="percentage">
            <p>{selectedPartner}</p>
            <div>
              <Input
                name="percentage"
                placeholder="00 %"
                value={percentage}
                onChange={(e) =>
                  e && Number(e.target.value)
                    ? setPercentage(e.target.value)
                    : e.target.value.length === 0
                    ? setPercentage('')
                    : null
                }
                error={submit && percentage === ''}
                texterror={
                  submit && percentage === '' ? 'Campo obrigatório' : ''
                }
              />
            </div>
          </div>
        ) : null}

        <Button
          size="small"
          color="primary"
          variant="outlined"
          fullWidth={false}
          onClick={() => history.push('/partners')}>
          + Criar novo parceiro
        </Button>

        <S.ButtonBox>
          <Button
            size="small"
            color="primary"
            variant="text"
            fullWidth
            onClick={() => setOpen(false)}>
            Cancelar
          </Button>
          <Button
            size="small"
            color="primary"
            variant="contained"
            fullWidth
            onClick={() => addPartner()}>
            Adicionar
          </Button>
        </S.ButtonBox>
      </S.Form>
    </S.Container>
  )
}
